import service from './request'

// 登录
export function authLogin(param) {
  return service.post(`/users/login`, param)
}

// 获取用户信息
export function getUserInfo() {
  return service.get(`/users/info`)
}

// 注销
export function authLogout(param) {
  return service.post(`/users/logout`, param)
}

// 获取管理员列表
export function getUserList(param) {
  return service.get(`/users`, param)
}

// 获取管理员详情
export function getUserDetail(id) {
  return service.get(`/users/${id}`)
}

// 新增管理员
export function saveUser(param) {
  return service.post(`/users`, param)
}

// 更新管理员
export function updateUser(id, param) {
  return service.patch(`/users/${id}`, param)
}

// 删除管理员
export function delUser(id) {
  return service.delete(`/users/${id}`)
}

// 获取管理员操作日志列表
export function getUserLogList(param) {
  return service.get(`/userLogs`, param)
}